<template>
  <DBox
    :id="'booking-booking-booking_sidewindow-documents'"
    :addButton="false"
    :leftMenu="
      list.length > 0
        ? []
        : [
            {
              text: $t('select_template_to_create_document'),
              value: 'select-a-template-to-create-a-document',
              label: true,
            },
          ]
    "
  >
    <NTable
      class="artist-list dbox1"
      :id="'booking-booking-booking_sidewindow-artists'"
      :headers="listHeader"
      :items="list || []"
      :showNoItems="true"
      :config="tableConfig"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('date')" @click="(e) => onDocumentClick(item)">
            <span
              :class="`${
                item.signed_documents_id ? '' : 'ut-link ut-text-accent5'
              }`"
              >{{ documentDate(item) }}</span
            >
          </td>
          <td :title="getArtistName(item)" v-bind="tdcon('name')">
            <span> {{ getArtistName(item) }}</span>
          </td>
          <td
            :title="item.booking_template_name"
            v-bind="tdcon('template_name')"
          >
            <span>{{ item.booking_template_name }}</span>
          </td>
          <td v-bind="tdcon('document_status')">
            <div style="width: 100%; padding-left: 5px" class="ut-flex">
              <div
                class="circle-status"
                :style="{
                  backgroundColor: `${getItemType(item)}`,
                  width: '13px',
                  minWidth: '13px',
                  height: '13px',
                }"
              ></div>
              <span style="margin-left: 5px">{{
                statusText[`${getItemType(item)}`]
              }}</span>
            </div>
          </td>
          <!-- <td v-bind="tdcon('edit')">
            <div @click="onDocumentSendMail(item)" class="dt-icon-container">
              <img
                src="static/icons/edit.svg"
                :class="{'inactive': item.signed_documents_id}"
                class="dt-icon v5 s1"
                alt="Send Mail"
                title="Edit Document"
              />
            </div>
          </td> -->
          <td v-bind="tdcon('print')">
            <div @click="onDocumentView(item)" class="dt-icon-container">
              <img
                src="static/icons/printer.svg"
                class="dt-icon v5 s1"
                :alt="$t('view_document')"
                :title="$t('view_document')"
              />
            </div>
          </td>
          <td v-bind="tdcon('mail')">
            <div class="dt-icon-container">
              <img
                @click="onEnableOGButtonClick(item)"
                src="static/icons/email/email-grey.svg"
                class="dt-icon v5 s1"
                :title="$t('send_mail')"
                :alt="$t('send_mail')"
              />
            </div>
          </td>
          <td v-bind="tdcon('close')">
            <div
              class="dt-icon-container"
              @click="(e) => onDocumentDelete(e, item)"
              v-if="
                !item.signed_documents_id ||
                (item.signed_documents_id && !item.sign_time)
              "
            >
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                :alt="$t('delete_document')"
                :title="$t('delete_document')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>

    <v-dialog v-model="enableOGDialogFlag" width="562">
      <v-card class="dt-modal">
        <div class="dt-modal--header v2">
          {{ $t("enable_online_agreement") }}
        </div>

        <div class="dt-modal--body">
          <p>{{ $t("enable_online_agreement_question") }}</p>

          <p>
            {{ $t("enable_online_agreement_info") }}
          </p>
        </div>
        <div class="dt-modal--options">
          <button class="dt-button s6 v1" @click="enableOG">
            {{ $t("yes") }}
          </button>
          <button class="dt-button s6" @click="displayOnly">
            {{ $t("no_display_only") }}
          </button>
          <button class="dt-button s6" @click="cancelOG">
            {{ $t("cancel") }}
          </button>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sendMailToPromoterFlag" width="562">
      <MailToPromoter
        :mailData="mailData"
        @submit="onMailSubmit"
        @cancel="onMailCancel"
      />
    </v-dialog>
  </DBox>
</template>

<script>
import * as qs from "qs";
import MailToPromoter from "./mail-to-promoter";
import Dropdown from "../../../../plugins/dropdown/dropdown";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { getBaseUrl } from "../../../../services/http/http-client";
import { BookingService } from "../../services/booking-service";
import { openWindow, waitForAnimation } from "../../../../utility";
import { documentDate, SignedDocumentTypes } from "../../models/document.model";
import { firstHalfString } from "../../../../utility/fp";
import { BOOKING_URL } from "../../../../services/common-urls";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import NTable from "@/plugins/datatable/datatable";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
export default {
  components: {
    Dropdown,
    MailToPromoter,
    NTable,
  },
  data: () => ({
    documentViewerWindow: null,
    enableOGDialogFlag: false,
    sendMailToPromoterFlag: false,
    selectedDocument: null,
    mailData: defaultMailData(),

    tableConfig: createNTableConfig({
      headerStyle: 3,
      fullHeight: true,
      footer: false,
    }),
  }),
  props: ["booking"],
  computed: {
    statusText() {
      return {
        green: this.$t("sent_out_and_signed"),
        orange: this.$t('sent_out'),
        gray: this.$t('not_sent_out_yet'),
      };
    },
    list() {
      return this.booking?.documents || [];
    },
    artists: function () {
      return this.booking?.artists || [];
    },
    listHeader: function () {
      return [
        createTableHeader("date", { f: 1.4 }),
        createTableHeader("name", { f: 2 }),
        createTableHeader("template_name", { f: 3.5 }),
        createTableHeader("document_status", {
          f: 3.5,
          text: this.$t("status"),
        }),
        //  createTableHeader("edit", { mw: 30, text: false }),
        createTableHeader("print", { mw: 30, text: false }),
        createTableHeader("mail", { mw: 30, text: false }),
        createTableHeader("close", { mw: 30, text: false }),
      ];
    },
    contactIdPromoter: function () {
      return this.booking.cdate?.contact_id_promoter;
    },
  },
  methods: {
    getArtistName: function (item) {
      const aname = item?.subject?.split("-")[0].trim();
      const artist = this.artists?.find((e) => e.artist_name === aname);
      return artist?.artist_name || aname || item?.subject || aname;
    },
    onArtistNameClick: function (item) {
      console.log(item);
    },
    getItemType(document) {
      if (
        document.signed_documents_id &&
        document.signature_md5 &&
        document.signature_md5 != "NO_SIGN"
      ) {
        return "green";
      } else if (
        document.signed_documents_id &&
        (!document.signature_md5 || document.signature_md5 == "NO_SIGN")
      ) {
        return "orange";
      } else {
        return "gray";
      }
    },
    // getImgSrc(document) {
    //   if (document.signed_documents_id && document.signature_md5) {
    //     return "static/icons/contract/contact-active.svg";
    //   } else if (document.signed_documents_id && (!document.signature_md5 || document.signature_md5 == "NO_SIGN")) {
    //     return "static/icons/contract/contact-orange.svg";
    //   } else {
    //     return "static/icons/edit.svg";
    //   }
    // },
    onDocumentClick: function (document) {
      if (document.signed_documents_id) {
        return;
      }
      const url =
        getBaseUrl() +
        BOOKING_URL +
        "?section=bookings&action=open_document_editor&document_id=" +
        document.document_id;

      //openWindow(url,'title');

      window.open(url, "Document Editor", "_blank");
    },
    onInvoiceLineCurrencySelected: function (e, item) {},
    onInvoiceLinePriceBlur: function (e, item) {},
    onDocumentDelete: async function (event, document) {
      const confirmationResult = await confirmDelete(
        "Document",
        document.booking_template_name
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", {
          item: document,
        });
      }
      // const confirmationResult = await ConfirmationService.createP({
      //   body: `<h3 style="color:var(--text-accent);text-align:center">Do you really want to delete this Document?<br>${
      //     document.booking_template_name
      //   }</h3>`,
      //   results: [
      //     createConfirmResult({
      //       value: "Cancel"
      //     }),
      //     createConfirmResult({
      //       value: "OK",
      //       text: "OK",
      //       classes: ["v1"]
      //     })
      //   ]
      // });

      // // console.log({"confirmationResult": confirmationResult});

      // if (confirmationResult == "OK") {
      //   this.$emit("deleted", {
      //     item: document
      //   });
      // }
      // ConfirmationService.create({
      //   subject:
      //     `Do you really want to delete this Document?${document.booking_template_name}`,
      //   model: true,
      //   width: 500,
      //   completed: (res) => {
      //     switch (res) {
      //       case "OK": {
      //         this.$emit("deleted", {
      //           item: document,
      //         });
      //         break;
      //       }
      //       default: {
      //       }
      //     }
      //   },
      // });
    },
    onDocumentView: function (document) {
      const url = getDocumentViewURL(document);

      this.documentViewerWindow = window.open(
        url,
        "Template View",
        "height=768,width=1366"
      );
    },
    enableOG: function (event) {
      this.$emit("signed", {
        signedDocumentType: SignedDocumentTypes.Promoter_Agreement,
        documentId: this.selectedDocument.document_id,
        subject: this.selectedDocument.subject,
        signed_documents_id: this.selectedDocument.signed_documents_id,
      });
      this.enableOGDialogFlag = false;
    },
    displayOnly: function (event) {
      this.$emit("signed", {
        signedDocumentType: SignedDocumentTypes.Promoter_View,
        documentId: this.selectedDocument.document_id,
        subject: this.selectedDocument.subject,
        signed_documents_id: this.selectedDocument.signed_documents_id,
      });
      this.enableOGDialogFlag = false;
    },
    cancelOG: function (event) {
      this.enableOGDialogFlag = false;
    },
    onEnableOGButtonClick: function (document) {
      this.selectedDocument = document;
      this.enableOGDialogFlag = true;
    },
    onDocumentSendMail: function (document) {
      console.log("SIGNED", document.signed_documents_id);
      if (document.signed_documents_id) {
        return;
      }
      BookingService.findPromoterInterface(this.contactIdPromoter).then(
        (res) => {
          this.mailData = {
            ...this.mailData,
            ...res.data,
            document,
          };
          this.sendMailToPromoterFlag = true;
        }
      );
    },
    onMailSubmit: function (event) {
      this.$emit("sendmail", {
        promoterId: event.mailData.promoter_id,
        email: event.mailData.email1,
        displayName: event.mailData.client_display_name,
        emailBody: event.mailText,
        subject: event.mailSubject,
        documentId: event.mailData.document.document_id,
        contactIdPromoter: this.contactIdPromoter,
      });
      this.sendMailToPromoterFlag = false;
    },
    onMailCancel: function (event) {
      this.sendMailToPromoterFlag = false;

      waitForAnimation(() => {
        this.mailData = defaultMailData();
      });
    },
    isSignCompleteDocument(document) {
      return document.sign_time || document.signature_md5;
    },
    documentDate: documentDate,
  },
};

const defaultMailData = () => ({
  client_display_name: "",
  email1: "",
  promoter_id: undefined,
  promoter_interface: "",
  document: {
    subject: "",
  },
});

const getDocumentViewURL = (document) => {
  const { document_id, signed_documents_id } = document;
  // console.log({ document: document });
  if (signed_documents_id) {
    return `${getBaseUrl()}/booking.pl?${qs.stringify({
      section: "bookings",
      action: "print_signed_document",
      signed_documents_id: signed_documents_id,
    })}`;
  } else {
    return `${getBaseUrl()}/contacts.pl?${qs.stringify({
      section: "correspondence",
      action: "print_document",
      document_id: document_id,
    })}`;
  }
};
</script>

<style lang="scss" scoped>
.dbox-table {
  background: gray;

  --rest-cell-padding: 0px 5px;

  // table {
  //   table-layout: fixed !important;

  //   td:nth-child(3),
  //   td:nth-child(4),
  //   td:nth-child(5),
  //   td:nth-child(6) {
  //     width: 28px;
  //     max-width: 28px;
  //     padding: 0px 7px !important;
  //     i {
  //       font-size: 14px;
  //     }
  //   }
  // }
}

.dt-list-item {
  padding-right: 0px;
}

.dt-list-item--text {
  color: var(--text-5);
}
</style>
